<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
           <v-tabs
            v-model="tabs"
          >
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-if="canAddSystem" href="/system-email-template"> {{ 'System Emails' | translate}} </v-tab>
              <v-tab v-if="canAdd" href="#viewscheduledmailstab" active> {{ 'Scheduled Mails' | translate}} </v-tab>
              <v-tab v-if="canAddTriggered" href="/trigger-mail-template"> {{ 'Trigger Mails' | translate }} </v-tab>
              <v-tab v-if="canAddReminder" href="/reminder"> {{ 'Reminder Mails' | translate }} </v-tab>
          </v-tabs>

          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :headers="headers"
            :items="scheduledemailtemplates"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteaction="deleteMail"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteaction="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="canAdd" @click="addScheduledMail">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_SCHEDULED_EMAIL_TEMPLATES,
  DELETE_SCHEDULED_EMAIL_TEMPLATE,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "ScheduledMail",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_SCHEDULED_EMAIL_TEMPLATES, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Scheduled Mail Notifications",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      sc_temp_id: null,
      singleSelect: "",
      dialog: false,
      tabs: "viewscheduledmailstab"
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["scheduledemailtemplates",'currentUser']),
    frequencyType(){
      return [
          {value: 'dailyAt', text:this.$t('Daily')},
          {value: 'weeklyOn', text:this.$t('Weekly')},
          {value: 'monthlyOn', text:this.$t('Monthly')},
          {value: 'yearlyOn', text:this.$t('Yearly')},
      ]
    },
    headers () {
      return [
        { text: this.$t("Email Template id"), value: "sc_temp_id" },  
        { text: this.$t("Template Name"), value: "schedule_template_name" },        
        { text: this.$t("Frequency"), value: "frequency" },        
        { text: this.$t("Start Date"), value: "start_date" },        
        { text: this.$t("Start Time"), value: "start_time" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    },
    canAdd(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-scheduled-mails')){

          return true;
        }
      }
      return false;
    },
    canAddSystem(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-system-mails')){

          return true;
        }
      }
      return false;
    },
    canAddTriggered(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-trigger-mails')){

          return true;
        }
      }
      return false;
    },
    canAddReminder(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-reminder-mails')){

          return true;
        }
      }
      return false;
    },
  },
  methods: {
    addScheduledMail() {
      this.$router.push("/scheduled-mail-notification/add");
    },
    editing(id) {
      this.$router.push("/scheduled-mail-notification/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.sc_temp_id = id
    },
    async deleteMail() {
      await this.$store
        .dispatch(DELETE_SCHEDULED_EMAIL_TEMPLATE, this.sc_temp_id)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.sc_temp_id = null;
            await store.dispatch(FETCH_SCHEDULED_EMAIL_TEMPLATES, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>